import { Button, Tooltip, Typography, styled } from '@mui/material';
import { ReactElement } from 'react';
import {
  type PopoverProps,
  PopoverTrigger,
} from 'src/components/PopoverTrigger';
import Iconify from 'src/components/iconify';

type Props<P extends object> = {
  popover: (props: PopoverProps<P>) => ReactElement;
  context?: P | undefined;
  icon: string;
  title: string;
  disabled: boolean;
};

export const SettingsDevicesButton = <P extends object>({
  popover,
  context,
  icon,
  title,
  disabled,
}: Props<P>) => {
  return (
    <Tooltip title={title}>
      <div
        style={{
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        <PopoverTrigger<P> popover={popover} context={context}>
          <CustomButtonPopover disabled={disabled}>
            <Iconify icon={icon} flexShrink={0} />
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}
            >
              {title}
            </Typography>
            <Iconify icon="tabler:caret-down-filled" flexShrink={0} />
          </CustomButtonPopover>
        </PopoverTrigger>
      </div>
    </Tooltip>
  );
};

const CustomButtonPopover = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  width: '100%',
  svg: {
    width: 16,
    height: 16,
    color: theme.palette.text.secondary,
  },
}));
